/**
 * OrdersTable Section Component
 *
 * Composes DataTableProvider + DataTableContent with the sales order columns.
 * Handles server-side pagination and row click navigation.
 */

import { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { DataTableProvider } from '../../../DataTable/DataTableProvider';
import { DataTableContent } from '../../../DataTable/DataTableContent';
import { getSalesOrderColumns } from '../../../SalesOrderTable/columns';
import type { OrdersTableProps } from '../types';

export function OrdersTable({
  orders,
  isLoading = false,
  isFetching = false,
  onRowClick,
  onOrderIdClick,
  currentUser,
  className,
}: OrdersTableProps) {
  const columns = useMemo(() => getSalesOrderColumns({ onOrderIdClick, currentUser }), [onOrderIdClick, currentUser]);

  return (
    <div className={cn('flex flex-col', className)}>
      <DataTableProvider
        columns={columns}
        data={orders}
        isLoading={isLoading}
        isFetching={isFetching}
      >
        <DataTableContent
          onRowClick={onRowClick}
          emptyTitle="No orders found"
          className="[&_table]:min-w-[1495px]"
        />
      </DataTableProvider>
    </div>
  );
}
